// Actions

import axios from '@/axios.js'

export default {
  GetList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/list',
        params,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  GetList1({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/company/list',
        params,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  getAllSearchedDid({ commit }, list) {
    return axios({
      url: "/did/search",
      params: {
        npa: list.npa || '',
        state: list.state || '',
        lata: list.lata || '',
        pattern: list.pattern || '',
        count: list.count || 10,
      },
      method: "GET"
    }).then(res => {
      return res.data.payload;
    });
  },
  getStateList({ commit }) {
    return axios({
      url: "/state/list",
      method: "GET"
    }).then(res => {
      return res.data.payload;
    })
  },
  getCountryList({ commit }, params) {
    return new Promise(resolve => {
      axios({
        url: "/country/list",
        params: {
          order_by: 'nice_name',
          order_dir: 'asc',
          per_page: params.per_page ?  params.per_page : 1000,
          nice_name: params.nice_name || ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  getLataList({ commit }) {
    return axios({
      url: "/lata/list",
      method: "GET"
    }).then(res => {
      return res.data.payload;
    })
  },
  getNpaList({ commit }) {
    return axios({
      url: "/npa/list",
      method: "GET"
    }).then(res => {
      return res.data.payload;
    })
  },
  GetDid ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/did/${payload}`,
        method: 'GET'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  Add({ commet }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did',
        data: payload,
        method: 'POST'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  buyDid({ commit }, data) {
    return axios({
      url: "/did/order",
      data: data,
      method: "POST",
    })
  },
  Edit({ commet }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/did/${payload.id}`,
        data: payload.data,
        method: 'PATCH'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  Delete({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/did/${payload}`,
        method: 'DELETE'
      })
      .then(res => {
        if (res.data.success) {
          resolve()
        }
      })
      .catch(err => reject(err))
    })
  },
  MassDelete ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/mass_delete',
        data: payload,
        method: 'DELETE'
      })
      .then(res => {
        if (res.data.success) {
          resolve()
        }
      })
      .catch(err => reject(err))
    })
  },
  GetImportLogList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/kannel/import/log',
        params,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  ImportDid ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const form_data = new FormData()

      for (let key in payload) {
        form_data.append(key, payload[key])
      }

      axios({
        url: '/did/kannel/import',
        data: form_data,
        method: 'POST'
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
    })
  }
}
